<template>
  <div style="background: #f7f8fa; height: 100vh; width: 100vw">
    <van-nav-bar title="会员中心" v-if="appType !== 'ios'"/>
    <van-form style="margin-top: 10px;">
      <van-cell-group inset>
        <van-field
          name="用户名"
          label="用户名"
          placeholder="用户名"
          v-model="user.username"
          readonly
        ></van-field>
      </van-cell-group>
      <van-cell-group inset>
        <van-field
          name="到期日期"
          label="到期日期"
          :value="expireTime(user.end_date)"
          v-if="user.end_date"
          readonly
        ></van-field>
      </van-cell-group>
      <van-cell-group inset>
        <van-cell title="续费充值" is-link @click="showPlans = true" />
      </van-cell-group>
    </van-form>
    <van-popup v-model="showPlans" position="bottom" :style="{ height: '80%' }">
      <van-radio-group v-model="plan">
        <van-row v-for="item in plans" :key="item.plan_id" style="background-color: #fafafa;">
          <van-col span="2" style="display: flex; justify-content: right; margin-top: 40px;">
            <van-radio :name="item" style="margin-left: 42%;"></van-radio>
          </van-col>
          <van-col span="22">
            <van-card
              :price="item.price"
              :desc="item.desp"
              :title="item.name"
              @click="plan = item"
              thumb="https://www.zerofast.net/assets/images/logo.png"
            />
          </van-col>
        </van-row>
      </van-radio-group>
      <van-submit-bar :price="parseFloat(plan.price) * 100" button-text="提交订单" @submit="order" v-if="plan.price !== ''"/>
    </van-popup>
    <a-modal title="支付提示" v-model="showPayNotice" :cancel-text="'取消'" :ok-text="'已完成支付'" @ok="refresh">
      <h6>是否完成支付？</h6>
    </a-modal>
    <a-modal title="扫码支付" v-model="showQrPay" >
      <qr-code :text="qrUrl" style="display: flex; justify-content: center;"></qr-code>
    </a-modal>
  </div>
</template>

<script>
import VueQRCodeComponent from 'vue-qrcode-component'
import { baseMixin } from '@/libs/app-mixin'
import { getToken, getAppType } from '@/libs/util'
import { User, MemberPlan } from '@/api/model'
import { getUserInfo } from '@/api/user'
import { getPlans, orderPlan } from '@/api/plan'
import { Base64 } from 'js-base64'
var md5 = require('js-md5')

export default {
  name: 'inAppMember',
  mixins: [baseMixin],
  components: {
    'qr-code': VueQRCodeComponent
  },
  data () {
    return {
      ua: navigator.userAgent,
      isTv: false,
      showPayNotice: false,
      showQrPay: false,
      user: User(),
      appType: getAppType(),
      now: 0,
      plan: MemberPlan(),
      plans: [],
      showPlans: false,
      qrUrl: ''
    }
  },
  methods: {
    checkTv () {
      const re = /tv/
      return re.test(navigator.userAgent)
    },
    getUserInfo () {
      getUserInfo().then(res => {
        this.user = res.result
      })
    },
    expireTime (time) {
      return this.timeStamp2FullString(parseInt(time) - 1)
    },
    getPlans () {
      getPlans({}).then(res => {
        this.plans = res.result
      })
    },
    order () {
      console.log(this.plan)
      orderPlan({
        plan: this.plan,
        is_tv: this.isTv
      }).then(res => {
        if (res.code !== 200) {
          this.$message.info(res.msg)
          return false
        }
        console.log(res)
        let redirectUri = location.protocol + '//' + location.host + '/#/in-app/trade/pay?trade_id=' + res.result.trade_id
        let token = getToken()
        let nonce = Math.round(new Date().getTime() / 1000)
        let sign = md5(Base64.encode(token) + nonce + 'zerofast')
        let url = location.protocol + '//' + location.host + '/#/in-app/sso?token=' + token +
          '&nonce=' + nonce + '&sign=' + sign + '&url=' + Base64.encode(redirectUri)
        if (!this.isTv) {
          if (getAppType() === 'ios') {
            setTimeout(() => {
              this.showPayNotice = true
            }, 1000 * 5)
            window.webkit.messageHandlers.safari.postMessage(url)
          } else if (getAppType() === 'android') {
            if (typeof window.App === 'undefined') {
              location.href = url
            } else {
              window.App.openBrowser(url)
            }
          }
        } else {
          this.qrUrl = url
          this.showPlans = false
          this.showQrPay = true
        }
      })
    },
    refresh () {
      location.reload()
    }
  },
  created () {
    this.now = Date.parse(new Date()) / 1000
    this.$parent.isLoadUser = false
    this.$parent.showHeader = false
    this.$parent.showFooter = false
    this.$parent.showSkeleton = false
    document.title = '会员中心'
  },
  mounted () {
    this.isTv = this.checkTv()
    this.getUserInfo()
    this.getPlans()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/inApp/Member.vue